import React from 'react'
import { Redirect } from 'react-router-dom'

export default function LimitRoute({ history,...props}) {
    return <Redirect to={{pathname: "/files"}} />
}